// APPLY BLACKHAWK FONT TO LAST WORK WITH BLKHAWK CLASS

document.addEventListener('DOMContentLoaded', function() {
  const titles = document.querySelectorAll('.blkhawk');
  
  titles.forEach(title => {
    const text = title.textContent.trim();
    const lastSpaceIndex = text.lastIndexOf(' ');

    if (lastSpaceIndex !== -1) {
      const lastWord = text.substring(lastSpaceIndex + 1);
      const newHTML = text.substring(0, lastSpaceIndex) + ' <span class="last-word">' + lastWord + '</span>';
      title.innerHTML = newHTML;
    } else {
      // If there's only one word or no space in the title
      title.innerHTML = '<span class="last-word">' + text + '</span>';
    }
  });
});